// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme';
import { TABLET_WIDTH } from 'commons/constants';

const {
  palette: { noodle },
  noodera: { fontTypes: nooderaFontTypes },
  palette: { neutral },
  underlineLink,
  fontTypes,
  spacing,
  noodera,
} = getTheme();
const SearchResultsListWrapper: StatelessFunctionalComponent<any> = styled.div`
  .search-results-list {
    &__section-container {
      margin-bottom: ${spacing.x3};
    }

    &__header {
      &__container {
        display: flex;
        justify-content: space-between;
      }

      &__text {
        ${noodera.fontTypes.font4Medium};
      }
    }

    &__subheader {
      ${fontTypes.font4};
    }

    &__view-all-btn {
      ${fontTypes.font4};
      border: none;
      background: none;
      color: ${noodle.primary};
      padding: 0 !important;
      margin-right: ${spacing.x3};
    }

    &__results-container {
      margin-bottom: ${spacing.x4};

      & > div {
        margin-bottom: ${spacing.x4};
      }
    }

    &__info-container {
      margin-bottom: ${spacing.x3};
    }
  }

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
  }
`;
export const StyledText: StatelessFunctionalComponent<any> = styled.span`
  ${nooderaFontTypes.font5Medium};
  ${underlineLink};
`;
export const StyledCountText: StatelessFunctionalComponent<any> = styled.span`
  ${nooderaFontTypes.font5};
  color: ${neutral.eighty};
`;
export default SearchResultsListWrapper;
